import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
//import { getSingleCourse } from '@/Services/api/CoursesService';
import store from '@/store';
//import { getBundleContent } from '@/Services/api/BundlesService';
import CourseDetails from '../views/SingleCourse.vue';
import AboutView from '../views/AboutView.vue';
import ContactView from '../views/Contact.vue';
import Courses from '@/views/Courses.vue';
import Blogs from '../views/Blogs.vue';
import SingleBlog from '../views/SingleBlog.vue';
import Events from '../views/Events.vue';
import EventDetails from '../views/EventDetails.vue';
import PackageDetails from '../views/Packages.vue';
import SignUp from '../views/SignUp.vue';
import Login from '../views/Login.vue';
import PrivacyTerms from '../views/PrivacyTerms.vue';
import FaqPage from '../views/FaqPage.vue';
import JoinUs from '../views/TeacherSignup.vue';
import Certificate from '../views/Certificate.vue';
import Wishlist from '../views/Wishlist.vue';
import MyCourses from '@/views/MyCourses.vue';
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
  },
  {
    path: '/blogs',
    name: 'blogs',
    component: Blogs
  },
  {
    path: '/blogs/:id',
    name: 'single-blog',
    component: SingleBlog
  },
  {
    path: '/courses',
    name: 'courses',
    component: Courses
  },
  {
    path: '/courses/:id',
    name: 'single-course',
    component: CourseDetails,
  },
  {
    path: '/events',
    name: 'events',
    component: Events
  },
  {
    path: '/events/:id',
    name: 'events-details',
    component: EventDetails
  },
  {
    path: '/packages/:id',
    name: 'packages',
    component: PackageDetails,
    // beforeEnter: async (to, from, next) => {
    //   try {
    //     const response = await getBundleContent(to.params.id); // Validate ID against your database
    //     if (response.data) {
    //       next(); // Course exists, proceed to the page
    //     } else {
    //       next('/error'); // Redirect to a not-found page if course doesn't exist
    //     }
    //   } catch (error) {
    //     next('/error'); // Handle error (e.g., network issue, invalid ID)
    //   }
    // },
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: Certificate
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: Wishlist
  },
  {
    path:'/faq',
    name:'faq',
    component: FaqPage
  },
  {
    path:'/terms',
    name:'terms',
    component: PrivacyTerms
  },
  {
    path: '/purchase',
    name: 'purchase',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/Purchase.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import(/* webpackChunkName: "wishlist" */ '../views/Cart.vue')
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import(/* webpackChunkName: "checkout" */ '../views/Checkout.vue')
  },
  {
    path: '/my-courses',
    name: 'my-courses',
    component : MyCourses,
  },
  {
    path: '/success',
    name: 'success',
    component: () => import(/* webpackChunkName: "success" */ '../views/SuccessPage.vue')
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUp,
   // meta: { hideHeader: true },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        next('/'); 
      } else {
        next(); 
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    //meta: { hideHeader: true },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        next('/'); 
      } else {
        next(); 
      }
    },
  },
  {
    path: '/join-us',
    name: 'teacher-signup',
    component: JoinUs,
    meta: { hideHeader: true },
  },
  {
    path: '/:pathMatch(.*)*', 
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../views/ErrorPage.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },

})


export default router
